module.exports = __webpack_public_path__ + "static/media/23.4fb3f68f.jpg";